// MIT License. See license.txt

if (tuduno.require) {
	tuduno.require("file_uploader.bundle.js");
} else {
	tuduno.ready(function () {
		tuduno.require("file_uploader.bundle.js");
	});
}
